import React, {Component} from 'react'
import {Modal, Form, Row, Col, Input, Button, Select} from 'antd'
import dataSourceAPI from '../../../apis/dataSource'
import {Base64} from 'js-base64'
import {withTranslation} from 'react-i18next'

class CopyModal extends Component {
  formRef = React.createRef()
  state = {
    customerList: []
  }

  componentDidMount = () => {
    dataSourceAPI.customerAction().then(res => {
      this.setState({
        customerList: res.data.data
      })
    })
  }

  handleOk = () => {
    const {handleCancel, handleSearch, id} = this.props
    this.formRef.current.validateFields().then(fieldsValue => {
      let param = {
        id,
        sourceName: fieldsValue.sourceName,
        customer: fieldsValue.customer,
        configInfo: {
          apiUrl: Base64.encode(fieldsValue.apiUrl),
        }
      }
      dataSourceAPI.copyAction(param).then(res => {
        if (res.data.code === 0) {
          handleCancel('copyModalVisible')
          handleSearch()
        }
      })

    }).catch(err => { })
  }

  render() {
    const {copyModalVisible, handleCancel, copySourceType, t} = this.props
    return (
      <>
        <Modal
          title={`${t(`general.copy`)} ${t(`dataSource.dataSource`)}`}
          closable={true}
          onCancel={() => { handleCancel('copyModalVisible') }}
          visible={copyModalVisible}
          maskClosable={false}
          destroyOnClose={true}
          centered
          footer={[
            <Button key="Save" type="primary" onClick={this.handleOk}>{t(`general.save`)}</Button>,
            <Button key="Cancel" onClick={() => { handleCancel('copyModalVisible') }}>{t(`general.cancel`)}</Button>,
          ]}
        >
          <Form ref={this.formRef} key="addMapping" layout="vertical">
            <Row justify="start" gutter={[10, 0]}>
              <Col span={24}>
                <Form.Item name="sourceName" label={t(`dataSource.sourceName`)}
                           rules={[{
                             required: true,
                             message: `${t(`general.pleaseEnter`)} ${t(`dataSource.sourceName`)}`,
                             pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                           }]}>
                  <Input maxLength={100} placeholder={t(`general.pleaseEnter`)}/>
                </Form.Item>
              </Col>
              {
                copySourceType === 'HTTP' ?
                  <Col span={24}>
                    <Form.Item name="apiUrl" label={t(`dataSource.apiUrl`)}
                               rules={[{required: true, message: `${t(`general.pleaseEnter`)} ${t(`dataSource.apiUrl`)}`}]}>
                      <Input maxLength={100} placeholder={t(`general.pleaseEnter`)}/>
                    </Form.Item>
                  </Col> : null
              }
              <Col span={24}>
                <Form.Item name="customer" label={t(`dataSource.customer`)}
                           rules={[{
                             required: true,
                             message: `${t(`general.pleaseSelect`)} ${t(`dataSource.customer`)}`,
                             pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                           }]}>
                  <Select placeholder={t(`general.pleaseSelect`)} allowClear>
                    {
                      this.state.customerList.map((e, i) => {
                        return (
                          <Select.Option key={e.id} value={e.id}>{e.customer}</Select.Option>
                        )
                      })
                    }
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Modal>
      </>
    )
  }
}

export default withTranslation()(CopyModal)
